export const ArrowLeftIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.87883 17.2207L6 12.2207M6 12.2207L9.87883 7.2207M6 12.2207L18 12.2207"
      stroke="currentColor"
      strokeOpacity="0.86"
      strokeLinecap="round"
    />
  </svg>
);
